/**
 * Office Manager (renamed from the War council 2026-11-03; ids, routes and
 * the `reports.council` key are unchanged): findings about people, processes
 * and the setup (why, and what to change), the team's grades and coaching,
 * notes to staff, each office's check-in, moves with an owner and "did it
 * work", goals and alarm lines. Its own top-level entry under Home, not part
 * of Analytics. API `/v1/council`. Owner and "Office Manager access".
 */
import { defineManifest } from '@velora/contracts';
import { defineWebModule } from '../../app/module.js';

export default defineWebModule({
  manifest: defineManifest({
    id: 'council',
    title: 'Office Manager',
    version: '0.2.0',
    owner: 'WP3-ANALYTICS',
    entitlementKey: null,
    permissions: ['reports.council', 'money.view', 'settings.manage'],
    routes: [
      {
        id: 'council',
        path: '/council',
        title: 'Office Manager',
        officeScope: 'location-or-all',
        permission: 'reports.council',
        readsPhi: false,
      },
      {
        // The monitor wall: full screen, rotating war rooms, refreshes itself.
        id: 'wall',
        path: '/council/wall',
        title: 'Office Manager wall',
        officeScope: 'location-or-all',
        permission: 'reports.council',
        readsPhi: false,
      },
      {
        // The name people say: /office-manager opens /council.
        id: 'alias',
        path: '/office-manager',
        title: 'Office Manager',
        officeScope: 'location-or-all',
        permission: 'reports.council',
        readsPhi: false,
      },
    ],
    nav: [
      {
        // Its own entry right under Home (2026-11-03): not part of Analytics.
        label: 'Office Manager',
        group: 'dashboard',
        routeId: 'council',
        icon: 'briefcase-business',
        order: 1,
        permission: 'reports.council',
      },
    ],
    commands: [
      {
        id: 'council.open',
        title: 'Office Manager: findings, your team and office check-ins',
        keywords: [
          'office manager',
          'council',
          'war council',
          'war room',
          'findings',
          'team',
          'grades',
          'coaching',
          'staff',
          'notes',
          'morning brief',
          'scoreboard',
          'moves',
          'playbook',
        ],
        routeId: 'council',
        permission: 'reports.council',
      },
      {
        id: 'council.wall',
        title: 'Office Manager wall: view for monitors',
        keywords: ['wall', 'monitor', 'tv', 'full screen', 'kiosk', 'rotate offices'],
        routeId: 'wall',
        permission: 'reports.council',
      },
    ],
    sseEntityKeys: ['council_move', 'coaching'],
    phiReadPoints: [],
  }),
  pages: {
    council: () => import('./CouncilPage.js'),
    wall: () => import('./WallPage.js'),
    alias: () => import('./AliasRedirect.js'),
  },
});
